const SIDE_MENU_OPENED_KEY = 'SIDE_MENU_OPENED_KEY';

export const isSideMenuClosedInStorage = () => {
    return window.localStorage.getItem(SIDE_MENU_OPENED_KEY) === 'false';
};

export const closeSideMenu = () => {
    window.localStorage.setItem(SIDE_MENU_OPENED_KEY, 'false');
};

export const openSideMenu = () => {
    window.localStorage.setItem(SIDE_MENU_OPENED_KEY, 'true');
};